// @ts-nocheck
import React from "react";

/**
 * Early Adopters / feature previews — list, detail, and optional comment step.
 * State and API calls live in Copilot; this component is presentation-only.
 */
export default function EarlyAdoptersPanel({
  betaFeatures,
  onCardClick,
  onBackToList,
  onInterested,
  onWithdraw,
  onBackFromComment,
  onCommentChange,
  onSaveInterest,
  onCancelComment,
}) {
  const { isList, isDetail, isComment, dataList, selIndx, comment } =
    betaFeatures || {};
  const selected =
    selIndx != null && dataList?.[selIndx] ? dataList[selIndx] : null;

  const interested = (fp) => Boolean(fp?.Feature_Preview_Engagements__r);

  return (
    <div className="copilot-early-adopters container-fluid px-2 px-md-3 py-2 pb-4">
      <header className="copilot-early-adopters__header mb-3 mb-md-4">
        <p className="text-body-secondary small mb-0 copilot-early-adopters__lead">
          Preview upcoming capabilities and opt in to programs you care about.
        </p>
      </header>

      {isList && !isDetail && (
        <section aria-labelledby="ea-programs-heading">
          <h2
            id="ea-programs-heading"
            className="copilot-home-section-title mb-3"
          >
            Open programs
          </h2>
          {dataList && dataList.length === 0 && (
            <div
              className="copilot-early-adopters-empty text-center rounded-4 border border-secondary-subtle bg-body-tertiary py-5 px-3"
              role="status"
            >
              <span
                className="copilot-home-card-icon copilot-home-card-icon--early d-inline-flex align-items-center justify-content-center mb-3"
                aria-hidden
              >
                <i className="fa-solid fa-flask" />
              </span>
              <p className="fw-semibold text-body mb-1">
                No beta programs right now
              </p>
              <p className="text-body-secondary small mb-0">
                Check back later — new previews appear here when available.
              </p>
            </div>
          )}
          <div className="row g-3">
            {dataList &&
              dataList.map((fp, i) => (
                <div className="col-12" key={fp.Id || i}>
                  <button
                    type="button"
                    className="copilot-early-adopters-card copilot-changelog-card w-100 text-start border-0 p-0 bg-transparent"
                    onClick={() => onCardClick(i)}
                  >
                    <div
                      className="copilot-changelog-card__accent copilot-early-adopters-card__accent"
                      aria-hidden
                    />
                    <div className="copilot-changelog-card__body">
                      <div className="d-flex align-items-start gap-3">
                        <span
                          className="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 copilot-home-card-icon copilot-home-card-icon--early"
                          aria-hidden
                        >
                          <i className="fa-solid fa-stream" />
                        </span>
                        <div className="min-w-0 flex-grow-1">
                          <div className="d-flex align-items-start justify-content-between gap-2">
                            <h3 className="copilot-changelog-section-title mb-1 text-truncate">
                              {fp.Name}
                            </h3>
                            {interested(fp) ? (
                              <span
                                className="badge rounded-pill bg-warning text-dark flex-shrink-0"
                                title="You expressed interest"
                              >
                                <i
                                  className="fa-solid fa-star me-1"
                                  aria-hidden
                                />
                                Interested
                              </span>
                            ) : (
                              <span className="badge rounded-pill bg-secondary flex-shrink-0">
                                Open
                              </span>
                            )}
                          </div>
                          <p className="copilot-changelog-section-lead mb-2">
                            Feature preview — tap to read requirements and join or
                            leave.
                          </p>
                          <div className="d-flex flex-wrap gap-2 copilot-early-adopters-meta">
                            <span className="copilot-early-adopters-chip">
                              <span className="text-body-secondary">Status</span>{" "}
                              <strong>
                                {interested(fp) ? "Interested" : "Available"}
                              </strong>
                            </span>
                            <span className="copilot-early-adopters-chip">
                              <span className="text-body-secondary">
                                Engagement
                              </span>{" "}
                              <strong>
                                {interested(fp) ? "Active" : "None"}
                              </strong>
                            </span>
                          </div>
                          <div className="d-flex align-items-center gap-1 mt-2 small text-primary">
                            <span>View details</span>
                            <i
                              className="fa-solid fa-chevron-right"
                              style={{ fontSize: "0.65rem" }}
                              aria-hidden
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              ))}
          </div>
        </section>
      )}

      {isDetail && selected && (
        <section
          className="copilot-early-adopters-detail"
          aria-labelledby="ea-detail-title"
        >
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2"
              onClick={onBackToList}
            >
              <i className="fa-solid fa-arrow-left" aria-hidden />
              Back to programs
            </button>
          </div>

          <div className="copilot-changelog-card copilot-early-adopters-detail__hero mb-3">
            <div
              className="copilot-changelog-card__accent copilot-early-adopters-card__accent"
              aria-hidden
            />
            <div className="copilot-changelog-card__body">
              <div className="d-flex align-items-start gap-3 flex-wrap">
                <span
                  className="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 copilot-home-card-icon copilot-home-card-icon--early"
                  aria-hidden
                >
                  <i className="fa-solid fa-flask" />
                </span>
                <div className="min-w-0">
                  <h2
                    id="ea-detail-title"
                    className="h5 mb-2 text-body d-flex align-items-center flex-wrap gap-2"
                  >
                    <span className="text-truncate">{selected.Name}</span>
                    {interested(selected) ? (
                      <span title="Interested">
                        <i
                          className="fa-solid fa-star text-warning"
                          aria-hidden
                        />
                      </span>
                    ) : null}
                  </h2>
                  <div className="d-flex flex-wrap gap-2">
                    <span className="badge rounded-pill bg-body-secondary text-body border">
                      Feature preview
                    </span>
                    <span className="badge rounded-pill bg-body-secondary text-body border">
                      {interested(selected) ? "Engaged" : "Not engaged"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="copilot-changelog-card mb-3">
            <div className="copilot-changelog-card__body">
              <div className="copilot-changelog-detail-note">
                <div className="copilot-changelog-detail-section-title">
                  Requirements
                </div>
                <div
                  className="copilot-early-adopters__prose small"
                  dangerouslySetInnerHTML={{
                    __html: selected.Requirements__c || "",
                  }}
                />
              </div>
              <div className="copilot-changelog-detail-note">
                <div className="copilot-changelog-detail-section-title">
                  Summary
                </div>
                <div
                  className="copilot-early-adopters__prose small"
                  dangerouslySetInnerHTML={{ __html: selected.Summary__c || "" }}
                />
              </div>
            </div>
          </div>

          <div className="copilot-early-adopters-engage rounded-4 border border-secondary-subtle p-3 p-md-4 bg-body-tertiary">
            <h3 className="h6 text-body mb-2">Your participation</h3>
            <p className="small text-body-secondary mb-3 mb-md-4">
              {interested(selected)
                ? "You are enrolled in this preview. You can leave at any time."
                : "You are not enrolled yet. Opt in to get updates and share optional feedback."}
            </p>
            <div className="d-flex flex-wrap gap-2">
              {!interested(selected) ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onInterested}
                >
                  I&apos;m interested
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-outline-danger"
                  onClick={onWithdraw}
                >
                  I&apos;m no longer interested
                </button>
              )}
            </div>
          </div>
        </section>
      )}

      {isComment && selected && (
        <section
          className="copilot-early-adopters-comment"
          aria-labelledby="ea-comment-title"
        >
          <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2"
              onClick={onBackFromComment}
            >
              <i className="fa-solid fa-arrow-left" aria-hidden />
              Back to details
            </button>
          </div>

          <div className="copilot-changelog-card">
            <div
              className="copilot-changelog-card__accent copilot-early-adopters-card__accent"
              aria-hidden
            />
            <div className="copilot-changelog-card__body">
              <h2 id="ea-comment-title" className="h5 mb-1 text-body">
                {selected.Name}
              </h2>
              <p className="small text-body-secondary mb-3">
                Optional comments help us prioritize previews. You can skip this
                and still submit interest.
              </p>
              <label
                htmlFor="ea-interest-comment"
                className="form-label small fw-semibold"
              >
                Comments
              </label>
              <textarea
                id="ea-interest-comment"
                className="form-control copilot-early-adopters-textarea"
                rows={5}
                placeholder="Share context, use cases, or questions…"
                value={comment || ""}
                onChange={(e) => onCommentChange(e.target.value)}
              />
              <div className="d-flex flex-wrap gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onSaveInterest}
                >
                  Save interest
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={onCancelComment}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
